// 样式的改变总是由数据进行驱动
import { LANG, TAGS_VIEW } from '@/constant'
import { getItem, setItem } from '@/utils/storage'
import { getSystemDetail } from '@/api/auth.js'
export default {
    namespaced: true,
    state: () => ({
        sidebarOpened: true,
        language: getItem(LANG) || 'zh',
        tagsViewList: getItem(TAGS_VIEW) || [],
        systemInfo: null,
        managePassword: '',
        frontOrBack: '',
        prevRoute: null
    }),
    mutations: {
        SET_PREV_ROUTE(state, route) {
            state.prevRoute = route
        },
        // 区分前后台页面
        frontOrBackDifferentiation(state, route) {
            state.frontOrBack = route
        },
        triggerSidebarOpened(state) {
            state.sidebarOpened = !state.sidebarOpened
        },
        /**
         * 设置国际化
         */
        setLanguage(state, lang) {
            setItem(LANG, lang)
            state.language = lang
        },
        /**
         * 添加 tags
         */
        addTagsViewList(state, tag) {
            const isFind = state.tagsViewList.find((item) => {
                return item.path === tag.path
            })
            // 处理重复
            if (!isFind) {
                state.tagsViewList.push(tag)
                setItem(TAGS_VIEW, state.tagsViewList)
            }
        },
        /**
         * 删除 tag
         * @param {type: 'other'||'right'||'index', index: index} payload
         */
        removeTagsView(state, payload) {
            if (payload.type === 'index') {
                state.tagsViewList.splice(payload.index, 1)
            } else if (payload.type === 'other') {
                state.tagsViewList.splice(payload.index + 1, state.tagsViewList.length - payload.index + 1)
                state.tagsViewList.splice(0, payload.index)
            } else if (payload.type === 'right') {
                state.tagsViewList.splice(payload.index + 1, state.tagsViewList.length - payload.index + 1)
            }
            setItem(TAGS_VIEW, state.tagsViewList)
        },
        /**
         * 清空 tag
         */
        clearTagsView(state) {
            state.tagsViewList = []
            setItem(TAGS_VIEW, state.tagsViewList)
        },
        /**
         * 为指定的 tag 修改 title
         */
        changeTagsView(state, { index, tag }) {
            state.tagsViewList[index] = tag
            setItem(TAGS_VIEW, state.tagsViewList)
        },
        setSystemInfo(state, data) {
            state.systemInfo = data.about
            state.managePassword = data.manage_password
            setItem('system_info', data)
        }
    },
    actions: {
        async getSystemDetailFun(state) {
            const res = await getSystemDetail()
            state.commit('setSystemInfo', res)
        }
    },
    getters: {
        // 快捷获取上一个路由的 path
        prevRoutePath: (state) => state.prevRoute?.path,
        // 快捷获取 fullPath（区分同路由不同参数）
        prevRouteFullPath: (state) => state.prevRoute?.fullPath
    }
}
